import { useQuery } from '@tanstack/react-query';
import { getBrandList } from '../../api/brand.ts';
import imageCache from '../../utils/ImageCache.ts';

import type { BrandWithUrl } from '../../models/Brand.ts';
import { useMemo } from 'react';

export function useBrandList() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['brands'],
    queryFn: getBrandList,
  });

  const brands = useMemo(() => {
    return (data ?? []).map((brand) => {
      const image = imageCache.get(brand.id, brand.imageId);

      const brandWithUrl: BrandWithUrl = {
        ...brand,
        services: [...brand.services].sort((a, b) => b.localeCompare(a)),
        currentSignedUrl: image ?? '',
      };

      return brandWithUrl;
    });
  }, [data]);

  return {
    brands,
    isLoading,
    error,
  };
}
